import declare from "dojo/_base/declare";
import Widget from "csi/form/Widget";
import Relationship from "csi/def/Relationship";
import StoreNamesConstructor from "csi/store/Names";
import Memory from "dojo/store/Memory";
import MatrixEditor from "csi/dgrid/MatrixEditor";
import locale from "csi/locale";
import csi from "csi/main";
import csiStore from "csi/store/_base";
import lang from "dojo/_base/lang";
import html from "csi/html";

const SizeCurveForm = declare(Widget, {

	QUANTITY: "Quantity",
	QUANTITY_PER_SIZE: "QuantityPerSize",
	SIZES: "Sizes",

	matrix: null,
	maxValue: 100000,

	/**
	 * @override
	 * Add sizes matric to the form
	 */
	_buildFields: function (fields) {
		this.inherited(arguments);
		this._addMatrix();
	},

	/**
	 * Form validation , make Data value available to action controller
	 * @param {Object} errorParams
	 */
	 validateForm(errorParams) {
		const matrixQtyValues = this.matrix.get("value").flat(1);
		const isInvalid = matrixQtyValues.some((element) => !Number.isInteger(element));
		if (isInvalid) {
			errorParams.message = locale.resource("InvalidSizeCurveQtyValues", [this.maxValue]);
			return false;
		}
		
		return this.inherited(arguments);;
	},

	/**
	 * Function to add size/quantity matrix to form
	 */
	_addMatrix: function () {
		const fd = this.defView.m_formData;
		let sizeRange = fd.getSelectedNode() || fd.getParent();
		let quantityPerSize;
		if (this.getSourceController().m_urlNode) {
			const sc = this.cacheView.get(this.getSourceController().m_urlNode);
			if (sc) {
				quantityPerSize = sc.QuantityPerSize;
				sizeRange = this.cacheView.get(sc.__Parent__);
			}
		}

		if (!sizeRange || sizeRange.$Type != "SizeRange") {
			return;
		}

		const matrixRow = html.create("tr", { class: "csiFormViewRow" }, this.getTooltipRootNode());

		// create label
		const th = html.create("th", { innerText: locale.resource(this.QUANTITY_PER_SIZE) }, matrixRow);
		th.classList.add("csiFormViewAlignTop");
		const tdSeparator = this._addSeparator(matrixRow, false);
		tdSeparator.classList.add("csiFormViewAlignTop");

		html.create("div", { style: "padding-top: 6px;" }, matrixRow);

		// form using csi-form-view-block is using display:block, so no need to create th or td
		const domNode = html.create("div", { style: "padding-top: 6px;" }, matrixRow);

		const rel = lang.mixin(new Relationship(), {
			m_id: "Sizes",
			m_url: sizeRange.$URL,
		});

		const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);

		const sizeStore = new StoreNamesConstructor(storeOptions);

		//Declare deferred
		const dfd = sizeStore.query();

		//Create Memory store from field store query result
		function _createMatrixStoreFromFieldDataStore(result, store): dojo.store.Memory<any> {
			const { idProperty, labelProperty } = store;
			return new Memory({
				labelProperty: "name",
				data: csi.transform(result, (item) => {
					const id = item[idProperty];
					return { id: id, name: item[labelProperty] };
				}),
			});
		}

		function _editorArgsCallback(/*Object */args, /*Object*/ row, /*Object*/ column): void {
			if (quantityPerSize) {
				args.value = quantityPerSize.shift();
			}
		}

		dfd.then((result) => {
			// matrix should always default to 0
			this.matrix = new MatrixEditor({
				defaultValue: 0,
				label: locale.resource(this.QUANTITY),
				editorArgs: { constraints: { min: 0, max: this.maxValue, fractional:false } },
				rowLabel: locale.resource(this.SIZES),
				rowStore: _createMatrixStoreFromFieldDataStore(result, sizeStore),
				editorArgsCallback: _editorArgsCallback,
			}).placeAt(domNode);

			Object.assign(fd, { matrixEditor: this.matrix });
		});
	},
});

export = SizeCurveForm;
